import { createRouter, createWebHashHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import ServiceInvoiceList from "../views/ServiceInvoiceListView.vue";
import ServiceInvoiceCreate from "../views/ServiceInvoiceCreateView.vue";
import serviceInvoiceView from "../views/viewServiceInvoice.vue";
import tailwindplayground from "../views/TailwindPlayground.vue";
import RegisterUserView from "@/views/RegisterUserView.vue";
import DashboardView from "@/views/DashboardView.vue";
import store from "@/store";

import axiosInstance from "@/utils/axios";

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView,
    meta: {
      layout: "General",
    },
  },

  {
    path: "/serviceInvoice/List",
    name: "serviceInvoiceList",
    component: ServiceInvoiceList,
    meta: {
      layout: "Account",
      requiresAuth: true,
    },
  },

  {
    path: "/serviceInvoice/Create",
    name: "serviceInvoiceCreate",
    component: ServiceInvoiceCreate,
    meta: {
      layout: "Account",
      requiresAuth: true,
    },
  },

  {
    path: "/serviceInvoice/view/:id",
    name: "ServiceInvoiceView",
    component: serviceInvoiceView,
    props: true,
    meta: {
      layout: "Account",
      requiresAuth: true,
    },
  },

  {
    path: "/user/register",
    name: "registerUserView",
    component: RegisterUserView,
    meta: {
      layout: "General",
    },
  },

  {
    path: "/serviceInvoice/dashboard",
    name: "dashboardView",
    component: DashboardView,
    meta: {
      layout: "Account",
    },
  },

  {
    path: "/tailwindplayground",
    name: "tailwindplayground",
    component: tailwindplayground,
    meta: {
      layout: "General",
    },
  },

];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("token");
  console.log("token here : ")
  console.log(token)
  if (to.meta.requiresAuth) {
    if (!token) {
      store.commit("CLEAR_USER_DATA");
      return next("/");
    }

    try {
      const loginRes = await axiosInstance.get("/api/user/verifyToken");

      store.commit("SET_USER_DATA", loginRes.data.user);

      next();
    } catch (err) {
      localStorage.removeItem("token");
      store.commit("CLEAR_USER_DATA");
      next("/");
    }
  } else {
    next();
  }
});

export default router;
